import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Invoice} from '../invoices';
import {InvoiceService} from '../invoices.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message, SelectItem} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {appConfig} from "../../../../app.config";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http, RequestOptions, ResponseContentType} from '@angular/http';
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {UserPictureComponent} from "../../../../components/user-picture";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {ItemsGroupsShowComponent} from "../../../setting/itemsGroups/itemsGroups-show/itemsGroups-show.component";
import {CurrenciesShowComponent} from "../../../setting/currencies/currencies-show/currencies-show.component";
import {formatDate} from "ngx-bootstrap/chronos";
import {CustomerService} from "../../../setting/customers/customer.service";
import {ItemService} from "../../../setting/items/items.service";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {CustomersShowComponent} from '../../../setting/customers/customers-show/customers-show.component';
import {ItemsShowComponent} from '../../../setting/items/items-show/items-show.component';
import {JournalsShowComponent} from "../../../fin/journals/journals-show/journals-show.component";
import {ReturninvoicesShowComponent} from "../../../pos/returninvoices/returninvoices-show/returninvoices-show.component";
import {RecieptVouchersShowComponent} from "../../../fin/reciept_vouchers/reciept_vouchers-show/reciept_vouchers-show.component";
import {ExpenseVouchersShowComponent} from "../../../fin/expense_vouchers/expense_vouchers-show/expense_vouchers-show.component";
import {PurchasesShowComponent} from "../../../pro/purchases/purchases-show/purchases-show.component";



@NgModule({

    imports: [CommonModule, FormsModule, DropdownModule,MyInputsModule,MessagesModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        InvoicesShowComponent
    ],
    entryComponents: [
        InvoicesShowComponent
    ],
    exports: [],
    providers: [SharedService, InvoiceService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-invoices-show',
    templateUrl: './invoices-show.component.html',
    styleUrls: ['./invoices-show.component.scss'],
    providers: [InvoiceService, ConfirmationService, MessageService, CustomerService,ItemService]
})

export class InvoicesShowComponent implements OnInit, AfterViewInit {
  id: string;
  invoice = new Invoice();
  @Input() refShow;
  bank: any[] = [];
  // picture:string;x
  applog: AppLogComponent;
  parent_name: any;
  @Input() scrId;

  closeResult: string;
  lang: string;

  parent:any;
  @Input() modelName;
  @Input() delId;
  @Input() oldData;
  @Input() newData;
  @Input() newDatap;
  modalRef: NgbModalRef;

  @ViewChild('email') email;
  user_email: string;

  statusVal = [{'val': 1, 'title': 'Yes'}, {'val': 2, 'title': 'No'}];
  defVal = [{'val': 1, 'title': 'Yes'}, {'val': 0, 'title': 'No'}];
  disc_typeVal = [{'val': 1, 'title': 'Percentage'}, {'val': 2, 'title': 'Cost'}];
  country_typeVal = [{'val': 1, 'title': 'sweetened'}, {'val': 2, 'title': 'international'}];

  allinvdetails: any[] = [];
  today = formatDate(new Date(),"YYYY-MM-DD");

  Selectedpaymentway: any = 0;
  Selectedpaymentdetails: any = "";
  Selectedpaymentamount: any = 0;

  allpaid: any=0.0;
  allremain: any=0.0;
  allquty:any = 0;
  allcost_b_tax:any = 0;
  allcost_a_tax:any = 0;
  alltaxes:any = 0;
  allcostsforone:any = 0;
  alldiscountvalue:any = 0;
  alltaxesother:any = 0;
  sumtaxes:any = 0;

  Selecteditem: any;
  Selecteditemcost: any = 0.0;
  Selecteditemquty: any = 0.0;
  Selecteditemtotal_b_tax: any;
  Selecteditemtotal_a_tax: any;
  Selecteditemtax: any;
  Selecteditemdetails: any;

  itemCount: any[] = [];
  itemCountPayment: any[] = [];
  restoreInv: any;
  inv_old_list_arr: any = [];
  payment_old_list_arr: any = [];

  invoice_arr: any[] = [];
  invoice_list_arr: any[] = [];
  invoice_payment_arr: any[] = [];
  allcostsforoneafterDisc:any = 0;



  deletedrow: any[] = [];
  deletedrowPayment: any[] = [];
  selectedrow: any[] = [];

  customers: any[] = [];
  customersselected: any[] = [];
  customersselected_old: any[] = [];

  Selected_items: any[] = [];
  Selected_payment: any[] = [];
  items: SelectItem[] = [];
  Selected_items_db: string[] = [];
  selectedItem: string[] = [];
  selectedPayment: string[] = [];

  allitems: any = [];
  items_enhance: any = [];
  payment_enhance: any = [];
  //invoice_typeVal = [{'val': 1, 'title': 'type_cash'}, {'val': 2, 'title': 'آجلة'}];
  invoice_typeVal: any;
  invoice_typeVal_old: any;

  form: FormGroup;
  emailform: FormGroup;

    private sub: any;
    msgs: Message[] = [];
    public imgUrl = appConfig.publicUrl;
    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;
    private _emailButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private invoiceService: InvoiceService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                private customerservice: CustomerService,
                private itemservice: ItemService,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
      const userdata = JSON.parse(localStorage.getItem('currentUser'));

      if (userdata && userdata.lang) {
        this.lang = userdata.lang;
        this.user_email = userdata.email;
        this.translate.use(userdata.lang);
      }
      else
        this.lang="ar";
      this.sharedservice.setTitle(this.route.snapshot.data.title);
      this.sharedservice.setItemShow(InvoicesShowComponent);

      this.sharedservice.setButtons([
          {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
          {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
          {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
          {label: 'Send By Email', icon: 'fa-share', btnClass: 'btn-primary', btnId: 'emailButton'},
          {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
          {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},

      ]);
      this.sharedservice.setModelName('invoices');
      this.itemservice.getAllItems().subscribe(
        items => {
          this.allinvdetails = items.itemslist;
          this.allitems = items.itemslist;
          this.items_enhance = items.itemstable;
        });
    }

  open(content) {
    this.modalService.open(content).result.then((result) => {
    }, (reason) => {
      this.closeResult = 'Dismissed';
    });
  }

  sendByEmail(modal){
    modal('close modal');
    if(this.invoice){
      this.invoiceService.sendByEmail(this.invoice.id, this.emailform.controls['email'].value, this.lang).subscribe(
        res => {
          this.msgs = [];
          this.msgs.push({
            severity: 'success',
            summary: '',
          });
        }
      );
    }
  }

  showParent(){
    console.log(this.parent);
    const options: NgbModalOptions = {

      beforeDismiss: () => {
        console.log("before dismiss");
        //
        return true;
      }
    };
    this.modalRef = this.modalService.open(CustomersShowComponent, options);
    this.modalRef.componentInstance.scrId = this.parent;

    this.modalRef.result.then(() => {
      this.activeModal.dismiss('done');
    }, () => {
      console.log('Backdrop click')
    });
  }
  showItem(id){
    console.log(id);
    const options: NgbModalOptions = {

      beforeDismiss: () => {
        console.log("before dismiss");
        //
        return true;
      }
    };
    this.modalRef = this.modalService.open(ItemsShowComponent, options);
    this.modalRef.componentInstance.scrId = id;

    this.modalRef.result.then(() => {
      this.activeModal.dismiss('done');
    }, () => {
      console.log('Backdrop click')
    });
  }
  recordData() {
      const options: NgbModalOptions = {

          beforeDismiss: () => {
              // this.changePicUrl();
              return true;
          }
      };
      const modalRef = this.modalService.open(RecordDataComponent, options);
      modalRef.componentInstance.refRec = this.invoice;
      modalRef.componentInstance.rowId = '';

  }

    ngAfterViewInit() {
      if(!this.scrId && !this.oldData && !this.scrId) {
        this._editButton = document.getElementById('editButton');
        this._deleteButton = document.getElementById('deleteButton');
        this._newButton = document.getElementById('newButton');
        this._printButton = document.getElementById('printButton');
        this._searchButton = document.getElementById('searchButton');
        this._emailButton = document.getElementById('emailButton');


        if (this._editButton) {
          this._editButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/invoices/edit', this.id]);
          });
        }
        if (this._deleteButton) {
          this._deleteButton.onclick = ((e: any) => {
            e.preventDefault();
            this.deleteInvoice(this.invoice);
          });
        }
        if (this._newButton) {
          this._newButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/invoices']);
          });
        }
        
        if (this._searchButton) {
          this._searchButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/invoices/search']);
          });
        }

        if (this._emailButton) {
          this._emailButton.onclick = ((e: any) => {
            e.preventDefault();
            this.open(this.email);
          });
        }

        if (this._printButton) {
          this._printButton.onclick = ((e: any) => {
            e.preventDefault();
            const params = new URLSearchParams();
            const userdata = JSON.parse(localStorage.getItem('currentUser'));
            const tokenapi = userdata.api_token;
            const options = new RequestOptions({responseType: ResponseContentType.Blob });
            params.set('token', tokenapi);
            window.open(appConfig.apiUrl + 'invoices/print/'+this.id+'?'+ params.toString() );
          });
        }
      }
    }

  ngOnInit() {
    this.invoiceService.getAllCurrencies().subscribe(
      bank => {
          this.bank = bank;
      });


    this.sub = this.route.params.subscribe(params => {
        this.id = params['id'];
        this.parent_name = params['invoice_parent_group'];
      });

      this.form = new FormGroup({
        id: new FormControl({value: '', disabled: true}),
        customer_name: new FormControl({value: '', disabled: false}),
        customer_id: new FormControl({value: '', disabled: false}),
        total_free: new FormControl({value: '', disabled: true}),
        customer_cash: new FormControl({value: '', disabled: true}),
        paid: new FormControl({value: '', disabled: true}),
        remain: new FormControl({value: '', disabled: true}),
        disc_type: new FormControl({value: '', disabled: true}),
        disc_value: new FormControl({value: '', disabled: true}),
        date_time: new FormControl({value: '', disabled: true}),
        time: new FormControl({value: '', disabled: true}),
        type_country: new FormControl({value: '', disabled: false}),
      });

      this.emailform = new FormGroup({
        email: new FormControl({value: '', disabled: false}),
      });

      if (this.id) {
        this.activeModal.dismiss('');
        this.oldData = false;
        this.newData = false;
        this.delId = false;
        this.newDatap = true;
        localStorage.removeItem('filter');
        const msg = JSON.parse(localStorage.getItem('showMessages'));
        if (msg) {
          localStorage.removeItem('showMessages');
          this.msgs = msg;
          this.msgs = [];
        }



          this.invoiceService.getById(this.id).subscribe(
            invoice => {
              this.invoice_arr = invoice.invoice;
              this.invoice_list_arr = invoice.itemsdetails;
              this.invoice_payment_arr = invoice.itemspayment;
              this.selectedItem = invoice.selecteditems;
              this.parent = invoice.invoice.customer_id;

              this.id = invoice.invoice.id;
              this.invoice = invoice.invoice;
              this.form.patchValue({
                id: invoice.invoice.id,
                invoice_type: invoice.invoice.invoice_type,
                date_time: invoice.invoice.date_time,
                price_offer: invoice.invoice.price_offer,
                customer_id: invoice.invoice.customer_id,
                customer_name: invoice.invoice.customer_name,
                customer_type:invoice.invoice.customer_type,
                delegate_type:invoice.invoice.delegate_type,
                delegate_id:invoice.invoice.delegate_id,
                delegate_name:invoice.invoice.delegate_name,
                items_from_branch_id:invoice.invoice.items_from_branch_id,
                total_free:invoice.invoice.total_free,
                customer_cash: invoice.invoice.customer_cash,
                paid: invoice.invoice.paid,
                disc_type: invoice.invoice.disc_type,
                disc_value: invoice.invoice.disc_value,
                remain: invoice.invoice.remain,
                import_date: invoice.invoice.import_date,
                type_country: invoice.invoice.type_country,
                time: invoice.invoice.time,
            });

              if(invoice.invoice.invoice_type == 1){
                this.invoice_typeVal = "type_cash" ;

              }else{
                this.invoice_typeVal =  "type_notcash" ;
              }

              this.customerservice.getAllCustomers().subscribe(
                customers => {
                  this.customers = customers.customershow;
                  this.customersselected=[this.customers[invoice.invoice.customer_id]];
                });


              for(let i=0; i<this.invoice_list_arr.length; i++){
                let iserte = {item_id: this.invoice_list_arr[i].item_id, inx: i , cost:this.invoice_list_arr[i].cost, quantity:this.invoice_list_arr[i].quantity ,costafterdiscount:this.invoice_list_arr[i].costafterdiscount , cost_before_tax:parseFloat(this.invoice_list_arr[i].cost_before_tax).toFixed(2) , itemtax:this.invoice_list_arr[i].itemtax , tax_ammount:this.invoice_list_arr[i].tax_ammount , othertaxs:this.invoice_list_arr[i].othertaxs , other_tax_ammount:this.invoice_list_arr[i].other_tax_ammount , sumtaxs: ( parseFloat(this.invoice_list_arr[i].tax_ammount) + parseFloat(this.invoice_list_arr[i].other_tax_ammount) ).toFixed(2)  , cost_after_tax:this.invoice_list_arr[i].cost_after_tax , details:this.invoice_list_arr[i].details};
                this.Selected_items[i] = iserte;
              }
              this.itemCount = Array(this.Selected_items.length ).fill(2);

              for(let i=0; i<this.invoice_payment_arr.length; i++){

                let iserte = {payment_type: this.invoice_payment_arr[i].payment_type , payment_details:this.invoice_payment_arr[i].payment_details , payment_amount:this.invoice_payment_arr[i].amount};
                this.Selected_payment[i] = iserte;
              }
              this.itemCountPayment = Array(this.invoice_payment_arr.length ).fill(2);

              this.changallpaid();
              this.changeallremain();
            }, error => {
              console.log(error);
            }
          );


      }
      if (this.scrId) {
          this.oldData = false;
          this.newData = false;
          this.delId = false;

        this.invoiceService.getById(this.scrId).subscribe(
          invoice => {
            this.invoice_arr = invoice.invoice;
            this.invoice_list_arr = invoice.itemsdetails;
            this.invoice_payment_arr = invoice.itemspayment;
            this.selectedItem = invoice.selecteditems;
            this.parent = invoice.invoice.customer_id;
            this.id = invoice.invoice.id;
            this.invoice = invoice.invoice;
            this.form.patchValue({
              invoice_type: invoice.invoice.invoice_type,
              date_time: invoice.invoice.date_time,
              price_offer: invoice.invoice.price_offer,
              customer_id: invoice.invoice.customer_id,
              customer_name: invoice.invoice.customer_name,
              customer_type:invoice.invoice.customer_type,
              delegate_type:invoice.invoice.delegate_type,
              delegate_id:invoice.invoice.delegate_id,
              delegate_name:invoice.invoice.delegate_name,
              items_from_branch_id:invoice.invoice.items_from_branch_id,
              total_free:invoice.invoice.total_free,
              customer_cash: invoice.invoice.customer_cash,
              paid: invoice.invoice.paid,
              disc_type: invoice.invoice.disc_type,
              disc_value: invoice.invoice.disc_value,
              remain: invoice.invoice.remain,
              import_date: invoice.invoice.import_date,
              type_country: invoice.invoice.type_country,
              time: invoice.invoice.time,


            });

            if(invoice.invoice.invoice_type == 1){
              this.invoice_typeVal = "type_cash" ;

            }else{
              this.invoice_typeVal =  "type_notcash" ;
            }

            this.customerservice.getAllCustomers().subscribe(
              customers => {
                this.customers = customers.customershow;
                this.customersselected=[this.customers[invoice.invoice.customer_id]];
              });


            for(let i=0; i<this.invoice_list_arr.length; i++){
              let iserte = {item_id: this.invoice_list_arr[i].item_id, inx: i , cost:this.invoice_list_arr[i].cost, quantity:this.invoice_list_arr[i].quantity ,costafterdiscount:this.invoice_list_arr[i].costafterdiscount , cost_before_tax:parseFloat(this.invoice_list_arr[i].cost_before_tax).toFixed(2) , itemtax:this.invoice_list_arr[i].itemtax , tax_ammount:this.invoice_list_arr[i].tax_ammount , othertaxs:this.invoice_list_arr[i].othertaxs , other_tax_ammount:this.invoice_list_arr[i].other_tax_ammount  ,sumtaxs: (parseFloat(this.invoice_list_arr[i].other_tax_ammount) + parseFloat(this.invoice_list_arr[i].tax_ammount)).toFixed(2)  , cost_after_tax:this.invoice_list_arr[i].cost_after_tax , details:this.invoice_list_arr[i].details};
              this.Selected_items[i] = iserte;
            }
            this.itemCount = Array(this.Selected_items.length ).fill(2);

            for(let i=0; i<this.invoice_payment_arr.length; i++){

              let iserte = {payment_type: this.invoice_payment_arr[i].payment_type , payment_details:this.invoice_payment_arr[i].payment_details , payment_amount:this.invoice_payment_arr[i].amount};
              this.Selected_payment[i] = iserte;
            }
            this.itemCountPayment = Array(this.invoice_payment_arr.length ).fill(2);

            this.changallpaid();
            this.changeallremain();
          }, error => {
            console.log(error);
          }
        );


      }
      if (this.delId) {
        this.oldData = false;
        this.newData = false;
        this.newDatap = !this.newDatap ;
        this.invoiceService.getTrashedById(this.delId).subscribe(
          invoice => {
            this.invoice_arr = invoice.invoice;
            this.invoice_list_arr = invoice.itemsdetails;
            this.invoice_payment_arr = invoice.itemspayment;
            this.selectedItem = invoice.selecteditems;

            this.id = invoice.invoice.id;
            this.invoice = invoice.invoice;
            this.parent = invoice.invoice.customer_id;

            this.form.patchValue({
              invoice_type: invoice.invoice.invoice_type,
              date_time: invoice.invoice.date_time,
              price_offer: invoice.invoice.price_offer,
              customer_id: invoice.invoice.customer_id,
              customer_name: invoice.invoice.customer_name,
              customer_type:invoice.invoice.customer_type,
              delegate_type:invoice.invoice.delegate_type,
              delegate_id:invoice.invoice.delegate_id,
              delegate_name:invoice.invoice.delegate_name,
              items_from_branch_id:invoice.invoice.items_from_branch_id,
              total_free:invoice.invoice.total_free,
              customer_cash: invoice.invoice.customer_cash,
              paid: invoice.invoice.paid,
              disc_type: invoice.invoice.disc_type,
              disc_value: invoice.invoice.disc_value,
              remain: invoice.invoice.remain,
              import_date: invoice.invoice.import_date,
              type_country: invoice.invoice.type_country,
              time: invoice.invoice.time,


            });

            if(invoice.invoice.invoice_type == 1){
              this.invoice_typeVal = "type_cash" ;

            }else {
              this.invoice_typeVal =  "type_notcash" ;
            }



            this.customerservice.getAllCustomers().subscribe(
              customers => {
                this.customers = customers.customershow;
                this.customersselected=[this.customers[invoice.invoice.customer_id]];
                // console.log(this.customers);
                // console.log(this.customersselected);
              });


            for(let i=0; i<this.invoice_list_arr.length; i++){
              let iserte = {item_id: this.invoice_list_arr[i].item_id, inx: i , cost:this.invoice_list_arr[i].cost, quantity:this.invoice_list_arr[i].quantity ,costafterdiscount:this.invoice_list_arr[i].costafterdiscount , cost_before_tax:parseFloat(this.invoice_list_arr[i].cost_before_tax).toFixed(2) , itemtax:this.invoice_list_arr[i].itemtax , tax_ammount:this.invoice_list_arr[i].tax_ammount , othertaxs:this.invoice_list_arr[i].othertaxs , other_tax_ammount:this.invoice_list_arr[i].other_tax_ammount , sumtaxs: ( parseFloat(this.invoice_list_arr[i].tax_ammount) + parseFloat(this.invoice_list_arr[i].other_tax_ammount) ).toFixed(2)  , cost_after_tax:this.invoice_list_arr[i].cost_after_tax , details:this.invoice_list_arr[i].details};
              this.Selected_items[i] = iserte;
              this.selectedItem.push(this.invoice_list_arr[i].item_id);
              //console.log(this.invoice_list_arr[i]);
              //this.selectedItem[this.invoice_list_arr[i].item_id] = this.items_enhance[this.invoice_list_arr[i].item_id];
            }
            this.itemCount = Array(this.Selected_items.length ).fill(2);

            for(let i=0; i<this.invoice_payment_arr.length; i++){

              let iserte = {payment_type: this.invoice_payment_arr[i].payment_type , payment_details:this.invoice_payment_arr[i].payment_details , payment_amount:this.invoice_payment_arr[i].amount};;
              this.Selected_payment[i] = iserte;
            }
            this.itemCountPayment = Array(this.invoice_payment_arr.length ).fill(2);

            this.changallpaid();
            this.changeallremain();
            // console.log(this.Selected_items);
            // console.log(this.selectedItem);


          }, error => {
            console.log(error);
          }
        );
      }

      if (this.oldData && this.newData) {
        console.log("show",this.oldData,this.newData);
        this.restoreInv = this.oldData.invoice;
        this.restoreInv.inv_details = JSON.stringify(this.oldData.itemsdetails);
        this.restoreInv.inv_payment_details = JSON.stringify(this.oldData.itemspayment);
        this.inv_old_list_arr = this.oldData.itemsdetails;
        this.payment_old_list_arr = this.oldData.itemspayment;

        this.invoice_arr = this.newData.invoice;
        this.invoice_list_arr = this.newData.itemsdetails;
        this.invoice_payment_arr = this.newData.itemspayment;
        this.selectedItem = this.newData.selecteditems;
        this.selectedPayment= [];

        this.invoice = this.newData.invoice;
        this.parent = this.newData.invoice.customer_id;

          this.form.patchValue({
              id: this.newData.invoice.id,
            invoice_type: this.newData.invoice.invoice_type,
            date_time: this.newData.invoice.date_time,
            price_offer: this.newData.invoice.price_offer,
            customer_id: this.newData.invoice.customer_id,
            customer_name: this.newData.invoice.customer_name,
            customer_type: this.newData.invoice.customer_type,
            delegate_type: this.newData.invoice.delegate_type,
            delegate_id: this.newData.invoice.delegate_id,
            delegate_name: this.newData.invoice.delegate_name,
            items_from_branch_id: this.newData.invoice.items_from_branch_id,
            total_free: this.newData.invoice.total_free,
            customer_cash: this.newData.invoice.customer_cash,
            paid: this.newData.invoice.paid,
            disc_type: this.newData.invoice.disc_type,
            disc_value: this.newData.invoice.disc_value,
            remain: this.newData.invoice.remain,
            import_date: this.newData.invoice.import_date,
            type_country: this.newData.invoice.type_country,
            time: this.newData.invoice.time,

          });

        if(this.newData.invoice.invoice_type == 1){
          this.invoice_typeVal = "type_cash" ;

        }else{
          this.invoice_typeVal =  "type_notcash" ;;
        }
        if(this.oldData.invoice.invoice_type == 1){
          this.invoice_typeVal_old = "type_cash" ;
        }else{
          this.invoice_typeVal_old =  "type_notcash" ;
        }

        this.customerservice.getAllCustomers().subscribe(
          customers => {
            this.customers = customers.customershow;
            this.customersselected=[this.customers[this.newData.invoice.customer_id]];
            this.customersselected_old=[this.customers[this.oldData.invoice.customer_id]];
            // console.log(this.customers);
            // console.log(this.customersselected);
          });


        for(let i=0; i<this.invoice_list_arr.length; i++){
          let iserte = {item_id: this.invoice_list_arr[i].item_id, inx: i , cost:this.invoice_list_arr[i].cost, quantity:this.invoice_list_arr[i].quantity ,costafterdiscount:this.invoice_list_arr[i].costafterdiscount , cost_before_tax:parseFloat(this.invoice_list_arr[i].cost_before_tax).toFixed(2) , itemtax:this.invoice_list_arr[i].itemtax , tax_ammount:this.invoice_list_arr[i].tax_ammount , othertaxs:this.invoice_list_arr[i].othertaxs , other_tax_ammount:this.invoice_list_arr[i].other_tax_ammount , sumtaxs: ( parseFloat(this.invoice_list_arr[i].tax_ammount) + parseFloat(this.invoice_list_arr[i].other_tax_ammount) ).toFixed(2)  , cost_after_tax:this.invoice_list_arr[i].cost_after_tax , details:this.invoice_list_arr[i].details};
          this.Selected_items[i] = iserte;
          //console.log(this.invoice_list_arr[i]);
          this.selectedItem.push(this.invoice_list_arr[i].item_id);
        }
        this.itemCount = Array(this.Selected_items.length ).fill(2);

        for(let i=0; i<this.invoice_payment_arr.length; i++){

          let iserte = {payment_type: this.invoice_payment_arr[i].payment_type , payment_details:this.invoice_payment_arr[i].payment_details , payment_amount:this.invoice_payment_arr[i].amount};
          this.Selected_payment[i] = iserte;
        }

        let arrlen = 0;
        if(this.invoice_payment_arr.length > this.payment_old_list_arr.length) {
          arrlen = this.invoice_payment_arr.length;
        } else {
          arrlen = this.payment_old_list_arr.length;
        }
        for(let i=0; i<arrlen; i++) {
          if( typeof  this.invoice_payment_arr[i] !== "undefined" &&  typeof  this.payment_old_list_arr[i] !== "undefined" &&  this.invoice_payment_arr[i].payment_type == this.payment_old_list_arr[i].payment_type && this.invoice_payment_arr[i].amount == this.payment_old_list_arr[i].amount ) {
            this.selectedPayment[i] = this.invoice_payment_arr[i];
          }
        }

        this.itemCountPayment = Array(this.invoice_payment_arr.length ).fill(2);

        this.changallpaid();
        this.changeallremain();
      }
  }

  ConvertToInt(val , val2) {
    return parseFloat(val) + parseFloat(val2);
  }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        //console.log(userRoles.indexOf('pos.invoices.' + role));
        if (userRoles.indexOf('pos.invoices.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteInvoice(invoice: Invoice) {
      this.confirmationService.confirm({
        header: this.translate.instant('Confirm Delete'),
        message: this.translate.instant('Are you sure of delete ?'),
        icon: 'fa fa-trash',
        accept: () => {
          if (invoice) {
            this.invoiceService.delete(invoice.id).subscribe(
              res => {
                this.msgs = [];
                if(res.result){
                  this.msgs.push({
                    severity: 'success',
                    summary: '',
                    detail: this.translate.instant('Delete completed')
                  });
                  setTimeout(() => {
                    this.router.navigate(['/invoices']);
                  },1000);
                }
                else{
                  this.msgs.push({
                    severity: 'error',
                    summary: '',
                    detail: this.translate.instant(res.message)
                  });
                }
                window.scroll(0,0);
              }
            );
          }
        }
      });
    }

    recoverEdit(invoice: Invoice) {
      this.confirmationService.confirm({
        header: this.translate.instant('Confirm Undo Edit'),
        message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
        icon: 'fa fa-undo',
        accept: () => {
          if (invoice) {
            this.invoiceService.update(invoice).subscribe(
              res => {
                this.msgs = [];
                this.msgs.push({
                  severity: 'success',
                  summary: '',
                  detail: this.translate.instant('Data returned')
                });
                this.activeModal.close('done');
                this.router.navigate(['/invoices/show', invoice.id]);
              }
            );
          }
        }
      });
    }

    undotrashed() {
      this.confirmationService.confirm({
        header: this.translate.instant('Confirm Undo Delete'),
        message: this.translate.instant('Are you sure about recover deleted item?'),
        icon: 'fa fa-undo',
        accept: () => {
          if (this.delId) {
            this.invoiceService.restoreTrashedById(this.delId).subscribe(
              res => {
                this.msgs = [];
                this.msgs.push({
                  severity: 'success',
                  summary: '',
                  detail: this.translate.instant('Deleted invoice recovered')
                });
                this.activeModal.dismiss('close click');
                this.router.navigate(['/invoices/list']);
              }
            );
          }
        }
      });
    }


  showattachement(row_id: string) {
    //console.log(row_id)
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }

  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
      modalRef.componentInstance.rowId = row_id;
    }
  }


  changallpaid(){
    this.allpaid=0.0;
    for(let i=0; i<this.Selected_payment.length; i++){
      //console.log(this.Selected_payment[i].payment_amount);
      this.allpaid += parseFloat(this.Selected_payment[i].payment_amount);
    }
    let discv = this.form.controls['disc_value'].value;
    let disct =  this.form.controls['disc_type'].value;
    //console.log(discv);
    if(disct == 1){
      this.alldiscountvalue = (parseFloat(this.allcost_a_tax) * parseFloat(discv) / 100).toFixed(2) ;
    }else{
      this.alldiscountvalue = parseFloat(discv).toFixed(2);
    }

    this.allremain = (parseFloat(this.allcost_a_tax )- parseFloat(this.alldiscountvalue )- parseFloat(this.allpaid )).toFixed(2);

  }
  changeallremain(){
    this.allremain=0.0;
    this.allquty=0.0;
    this.allcostsforone=0.0;
    this.allcostsforoneafterDisc=0.0;
    this.allcost_b_tax=0.0;
    this.allcost_a_tax=0.0;
    this.alltaxes=0.0;
    //console.log(this.Selected_items);
    for(let i=0; i<this.Selected_items.length; i++) {
      //console.log(i);
      if (typeof  this.Selected_items[i] !== "undefined") {

        this.allquty += parseFloat(this.Selected_items[i].quantity);
        this.allcostsforone += parseFloat(this.Selected_items[i].cost);
        this.allcostsforoneafterDisc +=  parseFloat(this.Selected_items[i].costafterdiscount);
        this.allcost_b_tax += parseFloat(this.Selected_items[i].cost_before_tax);
        this.allcost_a_tax += parseFloat(this.Selected_items[i].cost_after_tax);
        this.alltaxes += parseFloat(this.Selected_items[i].tax_ammount);
        this.alltaxesother += parseFloat(this.Selected_items[i].other_tax_ammount);

      }
    }

    this.allquty = parseFloat(this.allquty).toFixed(2);
    this.allcostsforone = parseFloat(this.allcostsforone).toFixed(2);
    this.allcostsforoneafterDisc =  parseFloat(this.allcostsforoneafterDisc).toFixed(2);
    this.allcost_b_tax = parseFloat(this.allcost_b_tax).toFixed(2);
    this.allcost_a_tax = parseFloat(this.allcost_a_tax).toFixed(2);
    this.alltaxes = parseFloat(this.alltaxes).toFixed(2);
    this.alltaxesother = parseFloat(this.alltaxesother).toFixed(2);
    this.sumtaxes = (parseFloat(this.alltaxes) + parseFloat(this.alltaxesother)).toFixed(2);

    let discv = this.form.controls['disc_value'].value;
    let disct =  this.form.controls['disc_type'].value;
    //console.log(discv);
    if(disct == 1){
      this.alldiscountvalue = (parseFloat(this.allcost_a_tax) * parseFloat(discv) / 100).toFixed(2) ;
    }else{
      this.alldiscountvalue = parseFloat(discv).toFixed(2);
    }

    this.allremain = (parseFloat(this.allcost_a_tax )- parseFloat(this.allpaid )).toFixed(2);
  }

  changealldiscount(){
    let discv = this.form.controls['disc_value'].value;
    let disct =  this.form.controls['disc_type'].value;

    //console.log(disct);
    //console.log(discv);
    if(disct == 1){
      this.alldiscountvalue = (parseFloat(this.allcost_a_tax) * parseFloat(discv) / 100).toFixed(2) ;
    }else{
      this.alldiscountvalue = parseFloat(discv).toFixed(2);
    }


    for(let i=0 ; i < this.Selected_items.length ; i++){
      let total_After_discount:any = (parseFloat(this.Selected_items[i].cost)).toFixed(2);
      if(disct == 1){
        let discval:any = (parseFloat(this.Selected_items[i].cost) * parseFloat(discv) / 100).toFixed(2)
        total_After_discount =  total_After_discount - discval;
      }else{
        total_After_discount = (parseFloat(total_After_discount) - parseFloat(discv)).toFixed(2);
      }
      this.Selected_items[i].costafterdiscount = (parseFloat(total_After_discount)).toFixed(2);
      this.Selected_items[i].cost_before_tax = (parseFloat(total_After_discount) * parseFloat(this.Selected_items[i].quantity)).toFixed(2);

    }
    this.changeallremain();
  }

  openpopup(doc,type) {
    if(type === 0) {
      const modalRef = this.modalService.open(JournalsShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 2) {
      const modalRef = this.modalService.open(PurchasesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 3){
    } else if(type === 4){
      const modalRef = this.modalService.open(InvoicesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 5){
      const modalRef = this.modalService.open(ReturninvoicesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 6){
      const modalRef = this.modalService.open(RecieptVouchersShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 7){
      const modalRef = this.modalService.open(ExpenseVouchersShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    }

  }


}



// WEBPACK FOOTER //
// ./src/app/views/pos/invoices/invoices-show/invoices-show.component.ts